var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation",on:{"click":_vm.onClick}},[_c('VLangSelect'),_c('ul',{staticClass:"margin navigation-list"},[_vm._t("default",null,{"links":_vm.links})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }